import { TheWestSection } from '@news-mono/common'
import { metrics } from '@news-mono/component-library'
import {
    AdTargeting,
    getResolvedTopicPageMeta,
    StaticRoutes,
    Topic,
} from '@news-mono/web-common'
import {
    isFeatureEnabled,
    toFeatureState,
} from '@west-australian-newspapers/etrigan-feature-toggles-client'
import { PageMetaItemDTO } from '@west-australian-newspapers/publication-types'
import { layout } from '../../../App.routing'
import { getTopicSponsor } from '../../topic/get-topic-sponsor'
import {
    getFootyLivesHereHeader,
    getFootyLivesHereSocialImageMeta,
} from './footy-lives-here'
import {
    getAflCurationSierraComponent,
    getDefaultAflLayout,
} from './afl-route-component-layouts'

const getSocialImageMeta = (topic: Topic): PageMetaItemDTO[] => {
    return [
        {
            property: 'og:image',
            content: '/static/share-images/share-400x400.png?imwidth=1024',
        },
        {
            name: 'twitter:image',
            content: '/static/share-images/share-400x400.png?imwidth=1024',
        },
        {
            property: 'og:image:height',
            content: '400',
        },
        {
            property: 'og:image:width',
            content: '400',
        },
        {
            property: 'og:description',
            content: topic.seoDescription ?? `The Latest in ${topic.title}`,
        },
        {
            property: 'twitter:description',
            content: topic.seoDescription ?? `The Latest in ${topic.title}`,
        },
    ]
}

const defaultTopic: Topic = {
    id: 'sport/afl',
    title: 'AFL',
    seoTitle: 'AFL',
    metadata: {},
    parent: {
        id: 'sport',
        title: 'Sport',
        seoTitle: 'Sport',
        metadata: {},
    },
}

export const getAflRouteInfo: StaticRoutes<TheWestSection> = {
    '/sport/afl': ({ getAdTargeting, config, store, resolution }) => {
        const topic = getResolvedTopicPageMeta(resolution) ?? defaultTopic
        const section = 'default'

        const isFootyLivesHereEnabled = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'afl-footy-lives-here-custom-landing-page',
        )

        const { adUnitPath, ssAdUnits, topics } = getAdTargeting(
            'home',
            section,
            topic,
        )
        const adTargeting: AdTargeting = {
            pageId: topic?.title || defaultTopic.title,
            adUnitPath,
            ssAdUnits,
            topics,
        }

        const footyPageHeader = isFootyLivesHereEnabled
            ? getFootyLivesHereHeader(topic ?? defaultTopic)
            : [getAflCurationSierraComponent()]

        return {
            kind: 'page',
            heading: topic?.title || defaultTopic.title,
            section,
            pageType: 'topic',
            adTargeting,
            hideHeading: true,
            includeFromSectionInMetaDescription: !topic?.seoDescription,
            pageMeta: {
                description:
                    topic?.seoDescription ||
                    `The Latest in ${defaultTopic.title}`,
                title: topic?.seoTitle || defaultTopic.title,
                meta: isFootyLivesHereEnabled
                    ? getFootyLivesHereSocialImageMeta(topic)
                    : getSocialImageMeta(topic),
            },
            socialMeta: {},
            compositions: [
                layout.composition({
                    type: 'box',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: 'outerMargin',
                        verticalGutters: ['outerMargin', 'unset'],
                    },
                    contentAreas: {
                        main: [
                            ...(isFootyLivesHereEnabled
                                ? []
                                : [
                                      // Can remove breaking-news if needed
                                      layout.component({
                                          type: 'breaking-news',
                                          props: {
                                              dataDefinitionArgs: {
                                                  type: 'curation',
                                                  name: 'breaking-news',
                                                  offset: 0,
                                                  pageSize: 1,
                                              },
                                          },
                                      }),
                                      layout.component({
                                          type: 'breaking-news-promo-strap',
                                          props: {
                                              dataDefinitionArgs: {
                                                  type: 'curation',
                                                  name: 'breaking-news-promo-strap',
                                                  offset: 0,
                                                  pageSize: 1,
                                              },
                                          },
                                      }),
                                  ]),
                            layout.component({
                                type: 'breadcrumb',
                                props: {
                                    topic,
                                    sponsor: getTopicSponsor(topic),
                                    enableHeaderTag: true,
                                },
                            }),
                        ],
                    },
                }),
                layout.composition({
                    type: 'thor',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: [...footyPageHeader, ...getDefaultAflLayout()],
                    },
                }),
            ],
        }
    },
}
